/*
 * Rankings del dashboard (spec 4.2): los 10 más puntuales, los que llegan primero (adelanto promedio antes
 * de la hora oficial) y los 10 con más atrasos (minutos acumulados). Mínimo de jornadas: parametros del
 * servidor. Llegar temprano se muestra en verde: se reconoce, no se penaliza.
 */
import React from "react";
import RankingList from "../../components/RankingList";
import {durationLabel, formatNumber} from "../../utils/rows";

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

const RankingsPanel = ({datos}) => {
    const {rankings, parametros} = datos;
    const minimum = `Con al menos ${parametros.minimo_jornadas_ranking} jornadas de lunes a viernes.`;
    return (
        <div className="mc-grid mc-grid--3">
            <RankingList
                title="Los 10 más puntuales" hint={minimum} rows={rankings.mas_puntuales}
                emptyText="Nadie tiene todavía las jornadas mínimas en este rango."
                describe={(row) => ({
                    main: `${formatNumber(row.puntualidad, 1)} %`,
                    detail: plural(row.jornadas, 'jornada', 'jornadas'),
                    tone: 'up',
                })}/>
            <RankingList
                title="Los que llegan primero" hint={`Minutos antes de las ${parametros.hora_oficial}, en promedio. ${minimum}`}
                rows={rankings.llegan_primero} emptyText="Nadie llegó antes de la hora oficial en este rango."
                describe={(row) => ({
                    main: `${formatNumber(row.adelanto_promedio_min, 1)} min`,
                    detail: `${formatNumber(row.puntualidad, 1)} % puntual`,
                    tone: 'up',
                })}/>
            <RankingList
                title="Los 10 con más atrasos" hint={`Minutos acumulados después de las ${parametros.hora_oficial} + ${parametros.tolerancia_min} min.`}
                rows={rankings.mas_atrasos} emptyText="Nadie llegó tarde en este rango."
                describe={(row) => ({
                    main: durationLabel(row.atraso_total_min),
                    detail: `${plural(row.jornadas_tarde, 'día tarde', 'días tarde')} de ${row.jornadas}`,
                    tone: 'down',
                })}/>
        </div>
    );
};

export default RankingsPanel;
